<template>
  <div v-if="lots != null">
    <h2 class="subtitle">Lot History</h2>
    <div class="datamate">
      <table class="table is-fullwidth ">
        <thead>
          <tr>
            <th>LOT</th>
            <th>HEAD</th>
            <th>TYPE</th>
            <th>AVG. WEIGHT</th>
            <th>WEIGHT RANGE</th>
            <th>PRICE</th>
            <th>AGENT</th>
            <th>PAINT</th>
            <th>TEETH</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(lot, index) in lots" :key="index">
            <td>{{ lot.lot }}</td>
            <td>{{ lot.head }}</td>
            <td>{{ lot.type }}</td>
            <td>{{ lot.avgWeight }}</td>
            <td>{{ lot.wt_range }}</td>
            <td>{{ lot.price_per }}</td>
            <td>{{ lot.agent }}</td>
            <td>{{ lot.paint }}</td>
            <td>{{ lot.teeth }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style></style>

<script>
import log from 'loglevel'
import { bus } from '../common/bus'

export default {
  name: 'LotTable',
  components: {},
  data() {
    return {
      lots: null
    }
  },
  mounted() {
    log.info('LotTable mounted')

    let statCtx = this

    bus.$on('lotPrevious', function(payload) {
      statCtx.lots = []
      payload.lots.reverse().forEach(function(v, i) {
        statCtx.lots[i] = {
          lot: v.lot,
          head: v.head,
          type: v.type,
          class: v.class,
          wt_range: v.wt_range,
          avgWeight: v.avg_weight,
          paint: v.paint,
          vendor: v.vendor,
          teeth: v.teeth,
          agent: v.agent,
          price_per: v.price_per
        }
      })
    })
  },
  destroyed() {
    bus.$off('lotPrevious')

    log.info('LotTable destroyed')
  }
}
</script>
